// @flow
import _ from 'lodash';

import ApiManager from './ApiManager';

// constants
import APIEndpoints from '../constants/APIEndpoints';

// -- utils
import DateUtils from '../utils/DateUtils';

// -- entities
import PaymentsList from '../entities/PaymentsList';
import PaymentStatistics from '../entities/PaymentStatistics';
import PayinList from '../entities/PayinList';
import PayoutList from '../entities/PayoutList';
import ChecksList from '../entities/ChecksList';
import ApiError from '../entities/ApiError';

class ApiPayment {

  /**
  *
  * @param fromTime
  * @param toTime
  */
  static getStatistics(restaurantId: string, fromTime: number, toTime: number, success: Function, failure: Function) {
    const endpoint = APIEndpoints.STATISTICS.replace('{restaurantId}', restaurantId);

    const requestOptions = {
      endpoint,
      query: {
        fromTime,
        toTime
      },
      success: (json: Object) => {
        // -- create the payment statistics object.
        const paymentStatistics: PaymentStatistics = new PaymentStatistics();
        paymentStatistics.fromJson(json);

        success(paymentStatistics);
      },
      failure: (apiError: ApiError) => {
        failure(apiError);
      }
    }

    ApiManager.get(requestOptions);
  }

  static getPayins(restaurantId: string, fromTime: number, toTime: number, success: Function, failure: Function) {

    const endpoint = APIEndpoints.PAYINS.replace('{restaurantId}', restaurantId);

    const requestOptions = {
      endpoint,
      query: {
        fromTime,
        toTime
      },
      success: (json: Object) => {

        const payinList: PayinList = new PayinList();
        payinList.fromJson(json);

        success(payinList);
      },
      failure: (apiError: ApiError) => {
        failure(apiError);
      }
    }

    ApiManager.get(requestOptions);
  }

  static getPayouts(restaurantId: string, fromTime: number, toTime: number, success: Function, failure: Function) {
    const endpoint = APIEndpoints.PAYOUTS.replace('{restaurantId}', restaurantId);

    const requestOptions = {
      endpoint,
      query: {
        fromTime,
        toTime
      },
      success: (json: Object) => {

        // json = {"fromTime":1477778400000,"toTime":1480546799000,"payouts":[{"id":5765687410688000,"restId":"16000208","vatPercent":0.2,"vatAmount":0.01,"feesFixedPerPayin":0.01,"feesFixedAmountExcludingVat":0.03,"feesVariablePercent":0.1,"feesVariableAmountExcludingVat":0.04,"amount":35.0,"grossAmount":35.98,"netAmount":35.0,"date":1479877211,"creationDate":1479877211396,"dateOfFirstPayment":1479816724491,"dateOfLastPayment":1479817389538,"status":"SUCCEEDED","reference":"Pizza-161122"},{"id":6597081946914816,"restId":"16000208","vatPercent":0.2,"vatAmount":0.01,"feesFixedPerPayin":0.01,"feesFixedAmountExcludingVat":0.01,"feesVariablePercent":0.1,"feesVariableAmountExcludingVat":0.03,"amount":32.0,"grossAmount":32.5,"netAmount":32.0,"date":1479358812,"creationDate":1479358813000,"dateOfFirstPayment":1479299276921,"dateOfLastPayment":1479299276921,"status":"SUCCEEDED","reference":"Pizza-161116"},{"id":6301139976847360,"restId":"16000208","vatPercent":0.2,"vatAmount":0.01,"feesFixedPerPayin":0.01,"feesFixedAmountExcludingVat":0.01,"feesVariablePercent":0.1,"feesVariableAmountExcludingVat":0.02,"amount":15.0,"grossAmount":15.6,"netAmount":15.0,"date":1478667611,"creationDate":1478667611593,"dateOfFirstPayment":1478606568455,"dateOfLastPayment":1478606568455,"status":"SUCCEEDED","reference":"Pizza-161108"}]};

        const payoutList: PayoutList = new PayoutList();
        payoutList.fromJson(json);

        success(payoutList);
      },
      failure: (apiError: ApiError) => {
        failure(apiError);
      }
    }

    ApiManager.get(requestOptions);
  }

  static getChecks(checksIds: Array<string>, success: Function, failure: Function) {

    if (_.isEmpty(checksIds)) {
      success(new PayoutList());
      return;
    }

    const requestOptions = {
      endpoint: APIEndpoints.CHECKS,
      query: {
        ids: _.join(_.uniq(checksIds), ',')
      },
      success: (json: Object) => {

        const checksList: ChecksList = new ChecksList();
        checksList.fromJson(json);

        success(checksList);
      },
      failure: (apiError: ApiError) => {
        failure(apiError);
      }
    }

    ApiManager.get(requestOptions);
  }

  static getUserPaymentsForRestaurant(restaurantId: string, fromTime: number, toTime: number, userId: string = '', success: Function, failure: Function) {

    const requestOptions = {
      endpoint: APIEndpoints.PAYMENTS,
      query: {
        restaurantId,
        userId,
        fromTime,
        toTime
      },
      success: (json: Object) => {

        const paymentsList:PaymentsList = new PaymentsList();
        paymentsList.fromJson(json);

        success(paymentsList);
      },
      failure: (apiError: ApiError) => {
        failure(apiError);
      }
    }

    ApiManager.get(requestOptions);
  }

}

export default ApiPayment;



// WEBPACK FOOTER //
// ./sdk/scripts/api/ApiPayment.js